import React from 'react'

import { Box, Grid } from '@mui/material'

import Detail from './Detail'
import List from './List'

import ClickAwayListener from '@mui/material/ClickAwayListener'

import SearchForm from './List/Form'
import DetailTitle from './Detail/Title'

const Validation = ({
  handleBillingAction,
  setOpenList,
  openList,
  selectedRow
}) =>
  <Box ml={3} mr={1}>
    <Box sx={{ opacity: !!openList ? 0.5 : 1, mb: 8, pb: 15 }} >
      <Box display='flex' flexDirection='column' gap={2}>
        <SearchForm />
        <Box hidden={!selectedRow}>
          <DetailTitle record_id={selectedRow} handleBillingAction={handleBillingAction} />
        </Box>
        <Box hidden={!selectedRow}>
          <Detail record_id={selectedRow} handleBillingAction={handleBillingAction} />
        </Box>
      </Box>
    </Box>
    <Box sx={{ position: 'fixed', display: 'flex', width: 1, bottom: 0, justifyContent: 'center' }} >
      <ClickAwayListener onClickAway={() => setOpenList(false)} mouseEvent={'onMouseUp'}>
        <Box sx={{ boxShadow: 6, borderRadius: 1, zIndex: 'modal', maxHeight: window.innerHeight - 60, overflow: 'scroll' }} >
          <List handleBillingAction={handleBillingAction} />
        </Box>
      </ClickAwayListener>
    </Box>
  </Box>


export default React.memo(Validation)
